export const ProductTypes = {
  INITIAL: "INITIAL",
  PRODUCT_REQUEST: "PRODUCT_REQUEST",
};

export const AuthTypes = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  LOGIN_FAILED: "LOGIN_FAILED",
};
